import type { StructureSlottingInsight } from "../api/rest";

export type SlottingType = "stray_load" | "consolidation" | "putaway_capacity";

/** Display order of the insight groups: most urgent first. */
const TYPE_ORDER: SlottingType[] = ["stray_load", "consolidation", "putaway_capacity"];

export interface SlottingGroup {
  type: SlottingType;
  items: StructureSlottingInsight[];
}

/**
 * ADR 172, slice S7: group a run's slotting insights by type in a fixed urgency order
 * (stray → consolidation → putaway), dropping any type with no items so the section renders
 * only the groups that exist. The backend already ranks within each type; this only buckets.
 */
export function groupSlottingInsights(insights: StructureSlottingInsight[]): SlottingGroup[] {
  return TYPE_ORDER
    .map((type) => ({ type, items: insights.filter((i) => i.type === type) }))
    .filter((g) => g.items.length > 0);
}

/** Human label for the node an insight points at: the grammar code, else the operator name,
 *  else the last path segment, else the raw id — mirrors the occupancy section's labelling. */
export function insightNodeLabel(
  insight: Pick<StructureSlottingInsight, "code" | "name" | "path" | "nodeId">,
): string {
  return insight.code ?? insight.name ?? insight.path.split("/").filter(Boolean).pop() ?? insight.nodeId;
}
